// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TermsOrPrivacyTemplate_wrapper__bM_8D","children-wrapper":"TermsOrPrivacyTemplate_children-wrapper__ZKBLH"};